export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bundle.db880c21214c0986cae5.worker.js");
}
